// test1698
(1698 && 0);
